import React from "react"
import Helmet from 'react-helmet';
import { graphql, Link } from 'gatsby'
import Layout from "../components/layout"
import PostLink from "../components/post-link"
import HeroHeader from "../components/heroHeader"

const IndexPage = ({
  data: {
    site,
    allMarkdownRemark: { edges },
    tagGroups,
    categoryGroups,
  },
}) => {

  const Posts = edges
    .filter(edge => !!edge.node.frontmatter.date) // You can filter your posts based on some criteria
    .map(edge => <PostLink key={edge.node.id} post={edge.node} />)

  return (
    <Layout>
      <Helmet>
        <title>{site.siteMetadata.title}</title>
        <meta name="description" content={site.siteMetadata.description} />
      </Helmet>
      <HeroHeader/>
      <section className="blog-section">
        <div className="section-heading">
          <p className="eyebrow">Latest posts</p>
          <h2>Development Notes</h2>
        </div>
        <div className="grids">
          {Posts}
        </div>
      </section>
      <section className="blog-section two-grids">
        <div>
          <p className="eyebrow">Categories</p>
          <div className="term-list">
            {categoryGroups.group.map(category => (
              <Link className="term" to={`/category/${category.fieldValue.toLowerCase()}`} key={category.fieldValue}>
                {category.fieldValue} ({category.totalCount})
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="eyebrow">Tags</p>
          <div className="term-list">
            {tagGroups.group.map(tag => (
              <Link className="term" to={`/tag/${tag.fieldValue.toLowerCase()}`} key={tag.fieldValue}>
                {tag.fieldValue} ({tag.totalCount})
              </Link>
            ))}
          </div>
        </div>
      </section>
      <section className="profile-strip">
        <div>
          <p className="eyebrow">About</p>
          <h2>Build small. Revisit later.</h2>
          <p>A personal tech blog for learning notes, experiments, and implementation ideas.</p>
        </div>
        <Link to="/about" className="button -primary">About this blog</Link>
      </section>
    </Layout>
  )
}

export default IndexPage
export const pageQuery = graphql`
  query indexPageQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { draft: { ne: true }, date: { ne: null } } }
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "YYYY年MM月DD日")
            path
            title
            thumbnail
            category
            tags
          }
        }
      }
    }
    tagGroups: allMarkdownRemark(
      filter: { frontmatter: { draft: { ne: true }, tags: { ne: null } } }
    ) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
    categoryGroups: allMarkdownRemark(
      filter: { frontmatter: { draft: { ne: true }, category: { ne: null } } }
    ) {
      group(field: frontmatter___category) {
        fieldValue
        totalCount
      }
    }
  }
`
